// src/utils/widgetDataUpdater.ts

import { isPopularItemsWidget } from './widgetPatterns';
import type { MenuItem } from '../redux/slices/menuItemsSlice';

/**
 * Widget interface for type safety
 */
interface Widget {
  type: string;
  data: any;
}

/**
 * Update widgets with menu data for popular items widgets
 * @param widgets - Array of widgets to update
 * @param menuData - Menu data from API
 * @returns Updated widgets array
 */
export function updateWidgetsWithMenuData(widgets: Widget[], menuData: MenuItem[]): Widget[] {
  return widgets.map(widget => {
    if (isPopularItemsWidget(widget.type)) {
      const existingSelectedIds = widget.data?.selectedItemIds || [];
      
      // Don't auto-select items - keep existing selectedItemIds as-is
      return {
        ...widget,
        data: {
          ...widget.data,
          menuData: menuData,
          selectedItemIds: existingSelectedIds  // Keep existing, don't auto-select
        }
      };
    }
    return widget;
  });
}
